import StarterKit from "./StarterKit";

import BlockMovie from "./blocks/BlockMovie";
import Zone5 from "./components/Zone5";

window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Blocks
	// Zone5.init();
	BlockMovie.init();

});
